import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Swal from 'sweetalert2'
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import HomeIcon from '@material-ui/icons/Home';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import Grid from '@toast-ui/react-grid';
import { format } from 'date-fns';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';

import PurchaseCreate from '../Suppliers/PurchaseCreate';
import PurchaseEdit from '../Suppliers/PurchaseEdit';
import PurchaseDelete from '../Suppliers/PurchaseDelete';

const excelIcon = '/icons/excel48.ico';
const ExcelJS = require('exceljs');

function PurchaseList() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료

  const gridRef = useRef();

  const [purchaseList, setPurchaseList] = useState([]);
  const [purSelectData, setPurSelectData] = useState([]); //업체리스트 가저오기
  const [supplier, setSupplier] = useState(''); //업체명
  const [saupjaNo, setSaupjaNo] = useState(''); //업체사업자번호
  const [upchejuso, setUpchejuso] = useState(''); //업체주소
  const [upcheYesNo, setUpcheYesNo] = useState('Yes'); //업체사용유무
  const [purchaseNameChange, setPurchaseNameChange] = useState('');
  const [purchaseCreateModal, setPurchaseCreateModal] = useState(false); //자료등록모달
  const [purchaseEditModal, setPurchaseEditModal] = useState(false); //자료수정모달
  const [purchaseDeleteModal, setPurchaseDeleteModal] = useState(false); //자료삭제모달
  const [purchaseEditValue, setPurchaseEditValue] = useState(false); //수정자료담기
  const [purchaseDeleteValue, setPurchaseDeleteValue] = useState(false); //삭제자료담기
  const [purchasePasswordTrue, setPurchasePasswordTrue] = useState(false); //삭제자료조건 스테이터
  const [selectTrue, setSelectTrue] = useState(false); //업체리스트 다시 불러오기

  //히스토리사용
  const history = useHistory();

  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    if (pwloading !== urlpw) {
      //window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login/');
    }
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료

  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        setPurSelectData(res?.data);
        setSelectTrue(false);
      })
  }, [selectTrue])

  //삭제조건 실행
  useEffect(() => {
    if (purchasePasswordTrue === true) {
      onDelete()
      setPurchasePasswordTrue(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchasePasswordTrue])

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const purchaseAPI = useCallback(() => {
    const url = '/api/PurchaseList/';
    const url01 = `/api/PurchaseList/${purchaseEditValue.Id}/`; //수정후 Id 쿼리 요청
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: { purchaseName: purchaseNameChange } }),
      fetchAllId: () => axios.get(url01, { params: { id: purchaseEditValue.Id } }), //조건조회요청
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          Swal.fire({
            title: "<h5 style='color:blue'>정상적으로 저장되었습니다.</h5>",
            timer: 1500,
            confirmButtonText: "나가기",
          })
          //alert('정상적으로 저장되었습니다.');
          // console.log(res.data);
        }).catch(error => {
          // alert("저장이 되지 않았습니다.[공란이 있는지 확인해야 합니다.]")
          Swal.fire({
            title: "<h5 style='color:red'>저장이 되지 않았습니다.[공란이 있는지 확인해야 합니다.]</h5>",
            confirmButtonText: "확인필요",
          })
          // console.log(error);
        }),
      update: (id, updatedRecord) => axios.put(url + id, updatedRecord).then((res) => {
        //alert('정상적으로 수정되었습니다.');
        Swal.fire({
          title: "<h5 style='color:blue'>정상적으로 수정되었습니다.</h5>",
          timer: 1500,
          confirmButtonText: "나가기",
        })
      }).catch(error => {
        //alert("수정이 안되고 있습니다[중복확인하시길 바랍니다].")
        Swal.fire({
          title: "<h5 style='color:red'>수정이 안되고 있습니다[중복확인하시길 바랍니다]</h5>",
          confirmButtonText: "확인필요",
        })
        // console.log(error);
      }),
      delete: (id) => axios.delete(url + id, { params: { purUpcheCode: purchaseDeleteValue.s_업체코드 } }).then((res) => {
        // alert("정상적으로 삭제가 실행했습니다.")
        Swal.fire({
          title: "<h5 style='color:blue'>정상적으로 삭제가 실행했습니다.</h5>",
          timer: 1500,
          confirmButtonText: "나가기",
        })
      }).catch(error => {
        //alert("삭제가 실패했습니다.")
        Swal.fire({
          title: "<h5 style='color:red'>삭제가 실패했습니다.</h5>",
          confirmButtonText: "확인필요",
        })
        // console.log(error);
      }),
      // download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [headers, purchaseDeleteValue.s_업체코드, purchaseEditValue.Id, purchaseNameChange]);

  const refreshPurchaseList = useCallback(async () => {
    await purchaseAPI()
      .fetchAll()
      .then((res) => {
        setPurchaseList(res?.data);
        //console.log(res.data);
      })
      .catch((err) => console.log(err));
  }, [purchaseAPI]);

  //수정후 Id 쿼리
  const refreshPurchaseListId = useCallback(async () => {
    await purchaseAPI()
      .fetchAllId()
      .then((res) => {
        setPurchaseList(res?.data);
      })
      .catch((err) => console.log(err));
  }, [purchaseAPI]);

  const addOrEdit = useCallback(async (formData) => {
    if (formData.get('Id') === '0')
      await purchaseAPI().create(formData)
        .then(res => {
          refreshPurchaseList();
        })
        .catch(err => {
          console.log(err)
        })
    else
      await purchaseAPI().update(formData.get('Id'), formData)
        .then(res => {
          // console.log(res.data)
          refreshPurchaseListId()
        })
        .catch(err => {
          console.log(err)
        })
  }, [purchaseAPI, refreshPurchaseList, refreshPurchaseListId])

  const onDelete = useCallback(() => {
    purchaseAPI()
      .delete(purchaseDeleteValue.Id)
      .then((res) => refreshPurchaseList())
      .catch((err) => console.log(err));
  }, [purchaseAPI, purchaseDeleteValue.Id, refreshPurchaseList]);

  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      {
        name: "edit", header: "수정", align: "center", width: 60,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
          //return '<button type="button" class="btn btn-outline-primary btn-sm">수정</button>';
        }
      },
      // { name: "Id", header: "Id", align: "left", width: 50 }, //숨김처리
      { name: "s_업체코드", header: "코드", align: "center", width: 50 },
      { name: "s_업체상호", header: "업체상호", align: "left", width: 160 },
      { name: "s_업체사업자번호", header: "사업자번호", align: "center", width: 110 },
      { name: "s_업체업종", header: "업체업종", align: "center", width: 130 },
      { name: "s_대표자성명", header: "대표자성명", align: "center", width: 80 },
      { name: "s_대표자전화", header: "대표메일", align: "center", width: 140 },
      { name: "s_업체전화", header: "업체전화", align: "center", width: 100 },
      { name: "s_업체팩스", header: "업체팩스", align: "center", width: 100 },
      { name: "s_업체관리자전화", header: "담당자전화", align: "center", width: 100 },
      { name: "s_업체관리자성명", header: "담당자성명", align: "center", width: 90 },
      { name: "s_지출내역", header: "지출내역", align: "center", width: 100 },
      { name: "s_은행명", header: "은행명", align: "center", width: 80 },
      { name: "s_계좌번호", header: "계좌번호", align: "center", width: 150 },
      { name: "s_예금주", header: "예금주", align: "center", width: 150 },
      { name: "s_업체주소", header: "업체주소", align: "left", width: 319 },
      { name: "s_업무구분", header: "자재구분", align: "center", width: 70 },
      { name: "s_업체자재불출유무", header: "OspYn", align: "center", width: 60 },
      { name: "s_사용유무", header: "업체Yn", align: "center", width: 60 },
      { name: "s_등록일자", header: "등록일자", align: "center", width: 120 },
      { name: "s_등록자", header: "등록자", align: "center", width: 80 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = purchaseList.map((row, index) => ({
    //id: row.id,
    No: index + 1,
    edit: '수정',
    Id: row.id,
    s_업체코드: row.s_업체코드,
    s_업체상호: row.s_업체상호,
    s_업체사업자번호: row.s_업체사업자번호,
    s_업체업종: row.s_업체업종 == null ? '' : row.s_업체업종,
    s_대표자성명: row.s_대표자성명 == null ? '' : row.s_대표자성명,
    s_대표자전화: row.s_대표자전화 == null ? '' : row.s_대표자전화,
    s_업체전화: row.s_업체전화 == null ? '' : row.s_업체전화,
    s_업체팩스: row.s_업체팩스 == null ? '' : row.s_업체팩스,
    s_업체관리자전화: row.s_업체관리자전화 == null ? '' : row.s_업체관리자전화,
    s_업체관리자성명: row.s_업체관리자성명 == null ? '' : row.s_업체관리자성명,
    s_지출내역: row.s_지출내역 == null ? '' : row.s_지출내역,
    s_은행명: row.s_은행명 == null ? '' : row.s_은행명,
    s_계좌번호: row.s_계좌번호 == null ? '' : row.s_계좌번호,
    s_예금주: row.s_예금주 == null ? '' : row.s_예금주,
    s_업체주소: row.s_업체주소 == null ? '' : row.s_업체주소,
    s_업무구분: row.s_업무구분,
    s_업체자재불출유무: row.s_업체자재불출유무,
    s_사용유무: row.s_사용유무,
    s_등록일자: row.s_등록일자,
    s_등록자: row.s_등록자,
    delete: '삭제'
  }));

//혜더 복합칼럼설정
const header = {
  height: 60,
  complexColumns: [
    {
      header: '구매업체계좌정보',
      name: '구매자재지출정보',
      childNames: ['s_지출내역', 's_은행명', 's_계좌번호','s_예금주']
    },
  ]
}

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        // background: 'pink',
        // border: '#C0C0C0',
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        // background: 'silver'
        background: '#D8D8D8'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = purSelectData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );

  const haneleSuppilerOnClick = ((e) => {
    setSelectTrue(true)
    //setPurchaseNameChange('')
  })

  const haneleSuppilerCodeOnChange = ((e) => {
    e.preventDefault()
    setSaupjaNo(e.target.value)
  })
  const haneleSuppilerCodeOnClick = ((e) => {
    //setPurchaseNameChange('')
  })

  const haneleSuppilerJusoOnChange = ((e) => {
    e.preventDefault()
    setUpchejuso(e.target.value)
  })
  const haneleSuppilerJusoOnClick = ((e) => {
    // setPurchaseNameChange('')
  })

  //구매업체사용유무
  const haneleSuppilerYesNoOnChange = ((e) => {
    e.preventDefault()
    setUpcheYesNo(e.target.value)
    // console.log(upcheYesNo);
  })

  //검색클릭 값변경
  const handleInputPurchaseNameChange = (e) => {
    e.preventDefault();
    setPurchaseNameChange(e.target.value);
  };

  //검색클릭
  const handleInputPurchaseNameEnter = (e) => {
    e.preventDefault();
    if (purchaseNameChange !== '' && e.key === 'Enter') {
      refreshPurchaseList(); // null이 아니면 실행됨
    }
    else {
      setPurchaseList([]);
    }
  };

  //조회 버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      s_업체코드: supplier.value ? supplier.value : null,   //업체코드
      s_업체사업자번호: evValue.get("saupjaNo") ? evValue.get("saupjaNo") : null,
      s_업체주소: evValue.get("upchejuso") ? evValue.get("upchejuso") : null,
      s_사용유무: upcheYesNo ? upcheYesNo : null,
    }
    // console.log(DataSerche);
    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/PurchaseList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, {
      params: {
        purchaseCode: DataSerche.s_업체코드,
        purchaseSaupjaNo: DataSerche.s_업체사업자번호,
        purchaseUpchejuso: DataSerche.s_업체주소,
        purchaseUpcheYesNo: DataSerche.s_사용유무
      }
    })
      .then((res) => {
        setPurchaseList(res.data);
        //console.log(res.data)
      })
  };

  //Grid 클릭처리
  const handleEditClick = ((ev) => {
    var rowKey = ev.rowKey
    // console.log(rowKey)
    const clickEditValue = gridRef.current.getInstance().getRow(ev.rowKey)
    // console.log(clickEditValue)

    if (ev.rowKey === rowKey && ev.columnName === 'edit') {
      setPurchaseEditValue(clickEditValue);
      setPurchaseEditModal(true);
    }
    else if (ev.rowKey === rowKey && ev.columnName === 'delete') {
      // console.log(clickEditValue)
      setPurchaseDeleteValue(clickEditValue);
      setPurchaseDeleteModal(true);
    }
    else {
      console.log('Grid 처리필드가 아님');
    }
  })

  //엑셀파일내보내기
  const exportExcelFile = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("구미업체리스트");
    sheet.properties.defaultRowHeight = 20;
    //엑셀타이틀넣기
    sheet.getCell(`A1`).value = "구매업체현황리스트";
    sheet.mergeCells('A1:I1');
    sheet.getCell(`A1`).alignment = { horizontal: 'center', vertical: "middle"};
    sheet.getCell(`A1`).font= { size: 20, bold: true, color: { argb: "ff1890ff" }} ;
    sheet.getRow(1).height = 30;
    

    const styleHeaderCell = (cell) => {
      cell.fill = {
        type: 'gradient',
        gradient: 'path',
        center:{left:0.5,top:0.5},
        stops: [
            {position:0, color:{argb:'ff1890ff'}},
            {position:1, color:{argb:'ff1890ff'}}
        ]
      };
      cell.border = {
        left: { style: "thin", color: { argb: "-100000f" } },
        top: { style: "thin", color: { argb: "-100000f" } },
        bottom: { style: "thin", color: { argb: "-100000f" } },
        right: { style: "thin", color: { argb: "-100000f" } },
      };
      cell.font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: { argb: "ff252525" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    };

  const headerRow = sheet.addRow(["업체코드", "시작", "종료", "업체명","사업자번호","지출내역","계좌번호","은행","예금주" ]);
  const headerWidths = [10,10,10,28,20,17,17,17,17];
    headerRow.eachCell((cell, colNum) => {
      styleHeaderCell(cell);
      sheet.getColumn(colNum).width = headerWidths[colNum - 1];
    });
        
    
    rows.forEach(({ s_업체코드, s_시작, s_종료, s_업체상호,s_업체사업자번호,s_지출내역,s_계좌번호,s_은행명,s_예금주 }) => {

      const rowDatas = [Number(s_업체코드), "", "", s_업체상호,s_업체사업자번호,s_지출내역,s_계좌번호,s_은행명,s_예금주];
      const appendRow = sheet.addRow(rowDatas);

      const styleDataCell = (cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffffffff" },
        };
        cell.border = {
          left: { style: "thin", color: { argb: "ff1890ff" } },
          top: { style: "thin", color: { argb: "ff1890ff" } },
          bottom: { style: "thin", color: { argb: "ff1890ff" } },
          right: { style: "thin", color: { argb: "-100000f" } },
        };
        cell.font = {
          name: "Arial",
          size: 10,
          color: { argb: "ff252525" },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      };

      appendRow.eachCell((cell, colNum) => {
        styleDataCell(cell, colNum);
          if (colNum === 1) {
            cell.font = {
              name: "Arial",
              size: 10,
              color: { argb: "ff1890ff" },
            };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
          }
          if (colNum === 4) {
            cell.font = {
              name: "Arial",
              size: 10,
              // color: { argb: "ff1890ff" },
            };
            cell.alignment = {
              vertical: "middle",
              horizontal: "left",
              wrapText: true,
            };
          }
          // if (colNum === 3) {
          //   cell.numFmt = "0,000";
          // }
      });
    });

      
    // console.log(purchaseList)

    // sheet.columns = [
    //   // {
    //   //   header: "id",
    //   //   key: 'id',
    //   //   width: 10
    //   // },
    //   {
    //     header: "코드",
    //     key: 's_업체코드',
    //     width: 10,
    //     style: { numFmt: '@', alignment: { horizontal: 'center' } },
    //     // style: { numFmt: '#,##0'} // 숫자콤마
    //   },
    //   {
    //     header: "시작",
    //     key: 's_시작',
    //     width: 10
    //   },
    //   {
    //     header: "종료",
    //     key: 's_종료',
    //     width: 10
    //   },
    //   {
    //     header: "업체명",
    //     key: 's_업체상호',
    //     width: 28
    //   },
    //   {
    //     header: "사업자번호",
    //     key: 's_업체사업자번호',
    //     width: 20,
    //     style: { numFmt: '@', alignment: { horizontal: 'center' } },
    //   },
    //   {
    //     header: "지출내역",
    //     key: 's_지출내역',
    //     width: 17
    //   },
    //   {
    //     header: "계좌번호",
    //     key: 's_계좌번호',
    //     width: 17
    //   },
    //   {
    //     header: "은행",
    //     key: 's_은행명',
    //     width: 17
    //   },
    //   {
    //     header: "예금주",
    //     key: 's_예금주',
    //     width: 17
    //   },
    // ]
    //  purchaseList?.map(row => {
    //   return(
    //     sheet.addRow({
    //       // id:row?.id,
    //       s_업체코드:Number(row?.s_업체코드),
    //       s_업체상호:row?.s_업체상호,
    //       s_업체사업자번호:row?.s_업체사업자번호,
    //       s_지출내역:row?.s_지출내역,
    //       s_계좌번호:row?.s_계좌번호,
    //       s_은행명:row?.s_은행명,
    //       s_예금주:row?.s_예금주,
    //     }),
    //     sheet.getCell('A1').alignment = { horizontal: 'center' },
    //     sheet.getCell('B1').alignment = { horizontal: 'center' },
    //     sheet.getCell('C1').alignment = { horizontal: 'center' },
    //     sheet.getCell('D1').alignment = { horizontal: 'center' },
    //     sheet.getCell('E1').alignment = { horizontal: 'center' },
    //     sheet.getCell('F1').alignment = { horizontal: 'center' },
    //     sheet.getCell('G1').alignment = { horizontal: 'center' },
    //     sheet.getCell('H1').alignment = { horizontal: 'center' },
    //     sheet.getCell('I1').alignment = { horizontal: 'center' }
    //   );
    // });

    workbook.xlsx.writeBuffer().then(function (data) {
      const timestamp ="구미업체리스트" + format(Date.now(),'yyyyMMddhhmm_ss');
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `${timestamp}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  
  }

  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매업체등록</h3>
        {/* <h3 style={{ margin: "1rem", color: "blue", textAlign: 'center' }}>구매업체등록현황</h3> */}
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12">
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ""}
                size="small"
                style={{ width: 250, marginLeft: 3, marginRight: 3 }}
                value={supplier ? supplier : setSupplier('%')}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="사업자번호"
                name="saupjaNo"
                value={saupjaNo}
                // autoComplete={saupjaNo}
                onChange={haneleSuppilerCodeOnChange}
                onClick={haneleSuppilerCodeOnClick}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="업체주소"
                name="upchejuso"
                value={upchejuso}
                // autoComplete={upchejuso}
                onChange={haneleSuppilerJusoOnChange}
                onClick={haneleSuppilerJusoOnClick}
              />
              <FormControl
                variant="outlined"
                style={{ minWidth: 120, float: 'center', marginRight: '12px', }}
                size="small"
              >
                <InputLabel>업체사용YesNo</InputLabel>
                <Select
                  variant="outlined"
                  value={upcheYesNo}
                  onChange={haneleSuppilerYesNoOnChange}
                  label="업체사용YesNo"
                >
                  {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                  <MenuItem value={'Yes'}>Yes</MenuItem>
                  <MenuItem value={'No'}>No</MenuItem>
                </Select>
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 110,
                  marginRight: 3,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                variant="contained"
                startIcon={<InsertDriveFileIcon />}
                style={{
                  background: '#00838f',
                  color: 'white',
                  height: 36,
                  width: 100,
                  marginRight: 3,
                  float: "center",
                }}
                onClick={() => {
                  setPurchaseCreateModal(true)
                }}
              >
                등록
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 110,
                  float: "center",
                }}
                onClick={() => {
                  window.location.href = "/home/index";
                }}
                // onClick={() => { history.push("/home/index"); }}  //이게 더빠름
              >
                홈이동
              </Button>

              <Button
                id="homemove"
                variant="contained"
                startIcon={<FeaturedPlayListIcon />}
                style={{
                  background: '#1565c0',
                  color: 'white',
                  height: 36,
                  width: 135,
                  marginLeft: 20,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/Materials/MaterialList');
                }}
              >
                자재등록이동
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<FeaturedPlayListIcon />}
                style={{
                  background: '#741b47',
                  color: 'white',
                  height: 36,
                  width: 145,
                  marginLeft: 3,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/MaterialsInput/MaterialInputList');
                }}
              >
                입출고등록이동
              </Button>
              {
                purchaseList.length !== 0 ? 
                  <Button 
                    // startIcon={<FeaturedPlayListIcon />}
                    style={{background:"blue",color:'white',paddingRight:'15px', marginLeft:"auto"}}
                    onClick={exportExcelFile}
                  >
                  <img src={excelIcon} style={{ margin: 0, paddingRight:0, width:'30px', height:'25px'}}  alt='' />
                    엑셀저장
                  </Button>
                : null
              }            
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="purchaseNameChange"
          value={purchaseNameChange}
          onChange={handleInputPurchaseNameChange}
          onKeyUp={handleInputPurchaseNameEnter}
          // onClick={() => {
          //   setPurchaseNameChange('');
          //   setSupplier('')
          //   setSaupjaNo('')
          //   setUpchejuso('')
          // }}
        />
      </div>
      <Container maxWidth="xl">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            scrollY={false}
            rowHeight={'auto'}
            //bodyHeight={650}
            bodyHeight={"auto"}
            minRowHeight={30}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50,
              frozenCount: 4, // 7개의 컬럼을 고정하고
              frozenBorderWidth: 1, // 고정 컬럼의 경계선 너비를 2px로 한다.
              resizable: true,
            }}
            ref={gridRef}
            onClick={handleEditClick}
          />
        </Box>
      </Container>
      {purchaseCreateModal === true ? <PurchaseCreate purchaseCreateModal={purchaseCreateModal} setPurchaseCreateModal={setPurchaseCreateModal}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {purchaseEditModal === true ? <PurchaseEdit
        purchaseEditModal={purchaseEditModal} setPurchaseEditModal={setPurchaseEditModal}
        purchaseEditValue={purchaseEditValue} setPurchaseEditValue={setPurchaseEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {purchaseDeleteModal === true ? <PurchaseDelete
        purchaseDeleteModal={purchaseDeleteModal} setPurchaseDeleteModal={setPurchaseDeleteModal}
        purchaseDeleteValue={purchaseDeleteValue} setPurchaseDeleteValue={setPurchaseDeleteValue}
        purchasePasswordTrue={purchasePasswordTrue} setPurchasePasswordTrue={setPurchasePasswordTrue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}
    </>
  )
}

export default PurchaseList;
